import { isEmpty } from 'lodash-es';
import { CustomerAccountDetailsType } from './customerAccountTransformSchema';
import { CustomerLookupResponse } from 'packages/tackle-api/src/co-sell-msft/customerLookup';
import { CustomerAccountToSelectedCustomerFieldsSchema } from './customerAccountTransformSchema';
import { MsftMappedFieldsType } from 'packages/tackle-api/src/data-mapper/getMsftReferralMappedFields';

export const getAddressFromAccountDetails = ({
  accountDetails,
}: {
  accountDetails: CustomerAccountDetailsType;
}) => {
  if (!accountDetails) return '';

  return `${accountDetails?.address1_line1 || ''} ${
    accountDetails?.address1_line2 || ''
  }, ${accountDetails?.address1_city || ''}, ${
    accountDetails?.address1_country || ''
  }`;
};

export const getSingleCustomerAccountDetails = ({
  customerLookupData,
}: {
  customerLookupData: CustomerLookupResponse;
}) => {
  if (!customerLookupData || isEmpty(customerLookupData)) return null;
  const managedAccounts = customerLookupData?.managedAccounts;
  const unManagedAccounts = customerLookupData?.unManagedAccounts;

  const allAccounts = [
    ...(managedAccounts || []),
    ...(unManagedAccounts || []),
  ];

  const accountDetails = allAccounts[0]?.customerAccountDetails;

  const accountDetailsParsed =
    CustomerAccountToSelectedCustomerFieldsSchema.parse(accountDetails);

  return accountDetailsParsed;
};

export const getCustomerLookupInputBody = ({
  formValues,
}: {
  formValues: MsftMappedFieldsType['customerLookupInput'];
}) => {
  const companyName = formValues?.companyName || '';
  const addressLine1 = formValues?.address?.addressLine1 || '';
  const countryCode = formValues?.address?.country || '';
  const region = formValues?.address?.region || '';
  const postalCode = formValues?.address?.postalCode || '';
  const city = formValues?.address?.city || '';

  const customerLookupPayload = {
    companyName: companyName?.toLowerCase()?.trim() || '',
    address: {
      addressLine1: addressLine1,
      city: city,
      state: region,
      postalCode: postalCode,
      country: countryCode?.toUpperCase()?.trim() || '',
    },
  };

  return customerLookupPayload;
};
